import { isPaytechPlatform, isWolfBTCPlatform } from '@/helpers/environmentHelper';
import { useState } from 'react';
import Navbar from '../Navbar';
import UniversalSidebar from '../UniversalSidebar';
import PortalFooter from './PortalFooter';

interface PortalLayoutProps extends React.PropsWithChildren {
    isAuthorized: boolean;
}

export default function PortalLayout({ children, isAuthorized }: PortalLayoutProps) {
    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <main className="flex h-full bg-brand-background justify-center lg:divide-x-[1px] lg:divide-brand-neutral-700 overflow-y-auto">
            <UniversalSidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} isAlwaysExpanded />
            <div className="flex flex-col h-full w-full lg:pl-[260px] lg:pt-[80px]">
                <Navbar />
                {children}
                {isAuthorized && !(isPaytechPlatform || isWolfBTCPlatform) && <PortalFooter />}
            </div>
        </main>
    );
}
